import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinPenyakit = createAsyncThunk(
    "penyakit/getMin",
    async ({search}, thunkAPI) => {

        const config = {
            headers: {Authorization: "Bearer " + user.Token},
            params: {"search": search},
        };
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+"master/penyakit/min",
                config
            );
            if (response.status === 200) {

                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getPenyakit = createAsyncThunk(
    "penyakit/get",
    async ({start, count, search}, thunkAPI) => {

        const config = {
            headers: {'Authorization': `Bearer ` + user.Token},
            params: {"start": start, "count": count, "search": search},
        };
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+"master/penyakit",
                config
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertPenyakit = createAsyncThunk(
    "penyakit/insert",
    async (obj, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"master/penyakit",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updatePenyakit = createAsyncThunk(
    "penyakit/update",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.put(
                process.env.REACT_APP_API_URL+"master/penyakit",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const penyakitSlice = createSlice({
    name: "penyakit",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinPenyakit.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinPenyakit.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinPenyakit.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getPenyakit.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getPenyakit.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getPenyakit.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertPenyakit.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertPenyakit.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertPenyakit.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updatePenyakit.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updatePenyakit.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updatePenyakit.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const penyakitSelector = (state) => state.penyakit;
